import { isAutoLinkTextInProtectedContext } from '#pplx/frontend/composer-sdk/internal/link/autoLinkText.js';
/**
 * Reads text and linebreaks recursively, without adding formatting or block separators.
 * Custom containers retain their descendants' text; other node types contribute no text.
 *
 * @param node - Serialized node whose literal text is needed, including its descendants.
 */
export function getSerializedTextContent(node) {
    switch (node.type) {
        case 'text':
            // SerializedTextNode requires string text, but SerializedLexicalNode is open:
            // its `type` is only a string, and `in` narrows `text` to unknown.
            // Retain the legacy missing-field fallback for unchecked saved JSON.
            if ('text' in node) {
                return node.text;
            }
            break;
        case 'linebreak':
            return '\n';
        default:
            break;
    }
    // Serialized node types are open-ended; nodes without text retain their children.
    if ('children' in node && Array.isArray(node.children)) {
        return node.children.map(getSerializedTextContent).join('');
    }
    return '';
}
function shouldSerializeAutoLinkNodeAsPlainText(node) {
    return node.type === 'autolink' && 'isUnlinked' in node && node.isUnlinked === true;
}
/**
 * Whether a serialized link should retain its literal label instead of Markdown link syntax.
 * Unlinked autolinks and links inside closed triple-backtick fences retain their labels.
 *
 * @returns Whether the link should retain its label, including unlinked autolinks.
 */
export function shouldSerializeLinkNodeAsPlainText({ node, context, }) {
    return (shouldSerializeAutoLinkNodeAsPlainText(node) ||
        (node.type === 'link' && context ? isAutoLinkTextInProtectedContext(context) : false));
}
//# sourceMappingURL=serializedNodeText.js.map